export class UaraActivity {
  constructor(form) {
    if (form) {
      this.isTeamEvent = form.isTeamEvent === 0 ? 0 : 1; // 报名类型 0-个人,1-组队
      this.uaraEventTypeId = form.uaraEventTypeId; // 活动类型
      this.name = form.name; // 活动主标题
      this.uaEventCityId = form.uaEventCityId; // 活动城市
      this.otherAddress = form.otherAddress; // 活动地址
      this.isNeedCoach = form.isNeedCoach === 0 ? 0 : 1; // 是否需要教练0需要 1不需要
      this.coachId = form.coachSelectVO && form.coachSelectVO.id;
      this.coachIds = form.coachIds;
      this.coachSelectVO = form.coachSelectVO;
      this.coachLevel = form.coachSelectVO && form.coachSelectVO.level;
      this.location =
        form.latitude && form.longitude
          ? `${form.latitude},${form.longitude}`
          : "0,0";
      this.url = form.url; // 用户名单路径
      this.excelName = form.excelName; // 用户名单文件名
      this.file = form.file; // 用户名单文件
      this.address = (form.address && form.address.id) || "";
      this.exportTime = [form.recruitmentBeginTime, form.recruitmentEndTime]; // 招募时间
      this.activityTime = [form.beginTime, form.endTime]; // 活动时间 训练周期 比赛日期
      this.isSpeciallyInvite = form.isSpeciallyInvite; // 是否为特邀
      this.isSecondaryScreening = form.isSecondaryScreening; // 是否为二次筛选
      this.numberOfRecruits = form.numberOfRecruits; // 招募人数
      this.teamNum = form.teamNum; // 团队数量
      this.maxTeamPeople = form.maxTeamPeople; // 组队最大人数
      this.minTeamPeople = form.minTeamPeople; // 组队最小人数
      this.participationNumber = form.participationNumber; // 报名人数
      this.alternateTotalNumber = form.alternateTotalNumber; // 候补人数
      this.courseArrangementImg = form.courseArrangementImg; // 课程安排
      this.explanation = form.explanation; // 课程说明
      this.remark = form.remark; // 备注
      this.interview = {
        offlineInterviewTime: form.offlineInterviewTime,
        detailedDescription: form.detailedDescription,
      }; // 线下面试
      this.differDay = form.differDay; // 开放时间
      this.registrationIsOver = form.registrationIsOver; // 截止时间
      this.isCalculationDuration = form.isCalculationDuration; // 是否时间活动时长
      this.isShow = form.isShow; // 是否在列表页显示
      this.activityImageVO = {
        activityListPagePicture: form.activityImageVO.activityListPagePicture,
        activityDetailsPageHeader: form.activityImageVO.activityDetailsPageHeader,
        shareCardImage: form.activityImageVO.shareCardImage,
        shareImage: form.activityImageVO.shareImage,
      };
      this.uaraStartRunningTimes = form.uaraStartRunningTimes?.map(({ beginTime, endTime, applyNum, surplusApplyNum }) => ({ time: [beginTime, endTime], applyNum, surplusApplyNum }));
      this.content = form.content; // 活动介绍
      this.competitionRules = form.competitionRules; // 赛事规则
      this.precautions = form.precautions; // 注意事项
    } else {
      this.clear();
    }
  }

  get exportTime() {
    if (this.recruitmentBeginTime && this.recruitmentEndTime) {
      return [this.recruitmentBeginTime, this.recruitmentEndTime];
    } else {
      return [];
    }
  }

  set exportTime(exportTime) {
    if (exportTime && Array.isArray(exportTime) && exportTime.length === 2) {
      this.recruitmentBeginTime = exportTime[0];
      this.recruitmentEndTime = exportTime[1];
    } else {
      this.recruitmentBeginTime = null;
      this.recruitmentEndTime = null;
    }
  }

  get activityTime() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set activityTime(activityTime) {
    if (activityTime && Array.isArray(activityTime) && activityTime.length === 2) {
      this.beginTime = activityTime[0];
      this.endTime = activityTime[1];
    } else {
      this.beginTime = null;
      this.endTime = null;
    }
  }

  setUaraStartRunningTimes() {
    this.uaraStartRunningTimes = this.uaraStartRunningTimes?.map(({ time, applyNum, surplusApplyNum }) => ({ beginTime: time[0], endTime: time[1], applyNum: applyNum === '' ? 0 : applyNum, surplusApplyNum }));
  }

  setNumTypeIdOne() {
    this.numberOfRecruits = Number(this.numberOfRecruits);
    this.participationNumber = Number(this.participationNumber);
    this.alternateTotalNumber = Number(this.alternateTotalNumber);
  }

  get location() {
    if (this.latitude && this.longitude) {
      return `${this.latitude},${this.longitude}`;
    } else {
      return "0,0";
    }
  }

  set location(location) {
    if (location) {
      this.latitude = location.split(",")[0];
      this.longitude = location.split(",")[1];
    } else {
      this.latitude = 0;
      this.longitude = 0;
    }
  }

  clear() {
    this.isTeamEvent = 0; // 0-个人,1-组队
    this.uaraEventTypeId = 1;
    this.name = '';
    this.uaEventCityId = 1;
    this.otherAddress = '';
    this.isNeedCoach = 0;
    this.coachId = "";
    this.coachIds = [];
    this.coachSelectVO = [];
    this.location = "";
    this.excelName = ""; // 用户名单文件名
    this.file = null; // 用户名单文件
    this.url = ""; // 用户名单保存路径
    this.exportTime = [];
    this.numberOfRecruits = null;
    this.teamNum = null; // 团队数量
    this.maxTeamPeople = null; // 组队最大人数
    this.minTeamPeople = null; // 组队最小人数
    this.activityTime = [];
    this.isSpeciallyInvite = 0;
    this.isSecondaryScreening = 0;
    this.participationNumber = null;
    this.alternateTotalNumber = null;
    this.courseArrangementImg = '';
    this.explanation = '';
    this.remark = '';
    this.interview = {
      offlineInterviewTime: null,
      detailedDescription: "",
    };
    this.differDay = 14;
    this.registrationIsOver = 1;
    this.isCalculationDuration = 1;
    this.isShow = 0;
    this.uaraStartRunningTimes = [{}, {}];
    this.activityImageVO = {
      activityListPagePicture: "",
      activityDetailsPageHeader: "",
      shareCardImage: "",
      shareImage: "",
    };
    this.competitionRules = '';
    this.content = '';
    this.precautions = '';
  }
}
